/**
 * Created by Alican Köker on 2019-03-20.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonHelper} from "../../../utils/EdisonHelper";
import {EdisonStackedSymbolOverlay} from "./EdisonStackedSymbolOverlay";
import {TimelineLite, TweenLite} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EdisonIndividualWPView} from "../../winpresentation/individual/EdisonIndividualWPView";

export class EdisonRespinOverlay extends BaseView {

    private _layer:ScalableLayer;
    private _overlayContainerSprite:PIXI.Sprite;
    private _overlays:EdisonStackedSymbolOverlay[] = [];
    private _gameMode:EdisonGameMode;
    private _nextMode:EdisonGameMode;
    private _yPadding:number = 0;
    private _modeChangeAnimTimeline:TimelineLite;
    private _orientation:Orientation;
    private _initResize:boolean = true;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.RESPIN_OVERLAY.name);

        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this._nextMode = event.params[0]);

        this.createGraphics();
    }

    private createGraphics():void {
        this._overlayContainerSprite = new PIXI.Sprite();

        this._layer.addChild(this._overlayContainerSprite);
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._orientation === resizeData.orientation && !this._initResize)
            return;

        this._initResize = false;

        this._yPadding = resizeData.orientation === Orientation.LANDSCAPE ? EdisonGameConfig.instance.REEL_AREA_POS_Y + 120 : EdisonGameConfig.instance.REEL_AREA_POS_Y_PORTRAIT + 120;

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
            this._gameMode = this._nextMode;
        }

        this._orientation = resizeData.orientation;

        for(let i:number = 0; i < this._overlays.length; i++) {
            let pos:number[] = this.getOverlayPosition(this._overlays[i].reelIndex);
            this._overlays[i].position.set(pos[0] + 75, pos[1] + this._yPadding);
        }
    }

    public playOverlay(symbol:string, reelId:number):void {
        let overlay:EdisonStackedSymbolOverlay = new EdisonStackedSymbolOverlay();

        this._overlayContainerSprite.addChild(overlay);

        let pos:number[] = this.getOverlayPosition(reelId);
        overlay.position.set(pos[0] + 75, pos[1] + this._yPadding);
        this._overlays.push(overlay);

        overlay.playAppearAnimation(symbol, reelId);
    }

    public playWildOverlays():TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        this._overlays.forEach((overlay) => {
            overlay.playGoldOverlayAnim();
        });

        return tl;
    }

    public restoreOverlay(symbol:string, reelId:number):void {
        let overlay:EdisonStackedSymbolOverlay = new EdisonStackedSymbolOverlay();

        this._overlayContainerSprite.addChild(overlay);

        let pos:number[] = this.getOverlayPosition(reelId);
        overlay.position.set(pos[0] + 75, pos[1] + this._yPadding);
        this._overlays.push(overlay);

        overlay.playRestore(symbol);
    }

    public tintOverlay(reelId:number):void {
        this._overlays.forEach((overlay) => {
            if(overlay.reelIndex === reelId)
                overlay.tint();
        });
    }

    public unTintOverlays():void {
        this._overlays.forEach((reel) => {
            reel.unTint();
        });
    }

    public removeOverlay():void {
        let tl:TimelineLite = new TimelineLite();

        this._overlays.forEach((overlay) => {
            tl.add(() => {
                overlay.playDisappearAnimation();
            });
        });

        tl.add(() => {
            this.resetView();
        }, .5);
    }

    public resetView():void {
        this._overlayContainerSprite.removeChildren();
        this._overlays = [];
    }

    private getOverlayPosition(reelId:number):number[] {
        return EdisonHelper.getSymbolPosition(reelId, 0);
    }
}